module.exports = __webpack_public_path__ + "img/products_omega.13db5a48.png";